<template>
    <transition name="back-to-top-fade">
        <v-flex
            class="vue-back-to-top"
            v-show="visible"
            :style="`bottom:${this.bottom};right:${this.right};`"
            data-qe-id="scroll-to-top_btn"
            @click="scrollToTop">
            <v-flex class="circle-button">
                <v-tooltip slot="append" top content-class="vue-back-to-top__tooltip">
                    <i slot="activator"  class="fas fa-chevron-up"></i>
                    <span>{{appCommonConstants.BACK_TO_TOP}}</span>
                </v-tooltip>
            </v-flex>
        </v-flex>
    </transition>
</template>

<script>
    import { appCommonConstants } from '@/components/appCommon.constants.js';

    export default {
        name: 'BackToTopForDialog',
        data() {
            return {
                appCommonConstants,
                visible: false,
                visibleoffset: 200,
            };
        },
        props: {
            right: {
                type: String,
                default: '100px',
            },
            bottom: {
                type: String,
                default: '60px',
            },
            refId: {
                type: String,
                required: true,
            },
        },
        mounted() {
            this.container.addEventListener('scroll', this.catchScroll);
        },
        destroyed() {
            this.container.removeEventListener('scroll', this.catchScroll);
        },
        computed: {
            container() {
                return document.getElementById(this.refId);
            },
        },
        methods: {
            catchScroll() {
                this.visible = this.container.scrollTop > parseInt(this.visibleoffset, 10);
            },
            scrollToTop() {
                const event = new CustomEvent('scroll', {});
                this.container.scroll({
                    top: 10, 
                    left: 0, 
                    behavior: 'smooth',
                });
                this.container.dispatchEvent(event);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .back-to-top-fade-enter-active,
    .back-to-top-fade-leave-active {
        transition: opacity .6s;
    }

    .back-to-top-fade-enter,
    .back-to-top-fade-leave-to {
        opacity: 0;
    }

    .vue-back-to-top {
        cursor: pointer;
        position: fixed;
        z-index: 1000;
        background-repeat: none;

        .circle-button {
            background-color: rgba($ypo-blue, 0.6);
            border-radius: 50%;
            color: $white;
            height: 24px;
            line-height: 24px;
            text-align: center;
            width: 24px;
            transition: 0.3s all ease;

            &:hover {
                background-color: $ypo-blue;
            }

            
        }
        @include breakpoint(xs) {
            display: none;
        }
        &__tooltip {
            z-index: 202 !important;
        }
    }
</style>
